import { Capacitor } from '@capacitor/core'

export const SERVER_ORIGIN = 'https://operation.etcsvip.com.cn'

// Only native builds need absolute service URLs; bundled assets and Web URLs stay unchanged.
export function serverUrl(path, native = Capacitor.isNativePlatform()) {
  if (native && (path.startsWith('/api/') || path.startsWith('/kb-media/'))) {
    return `${SERVER_ORIGIN}${path}`
  }
  return path
}
